<template>
    <div 
        class="tree-item" 
        :style="{'padding-left': 10 + 'px'}"
    >
        <div class="trail" >
            
            <div class="child-trail" v-if="level > 0">
                <svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 0L1 7.99988C1 12.4182 4.58172 15.9999 9 15.9999V15.9999" stroke="#E4E7EC"/>
                </svg>
                <!-- <svg width="9" height="32" viewBox="0 0 9 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.00001 16V16C4.58173 16 1.00001 12.4183 1.00001 8L1.00001 0L1 32" stroke="#E4E7EC"/>
                </svg> -->

            </div>
        </div>
        <div class="name-row">
            <CheckBox 
                :id="'checkbox-'+item.id"
                v-if="treeType == 'copy'"
                v-model="selected"
                :label="''"
                theme="site"
                @input="checkItem(item)"
            />
            <RadioButton
                :id="`radio-${item.id}`"
                v-else-if="treeType == 'move' && item.id != item_group_id"
                :value="item.id"
                :label="''" 
                :radio-value="item.id" 
                :selected-value="checkedSingleValue"
                @input="$emit('checkSingleValue', item.id)"
            />
            <div class="empty" v-else>
                <div class="circle">
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div class="parent-name" @click="expanded = !expanded" :class="{'expanded': expanded}">
                <span class="arrow" v-if="item[childrenKey] && item[childrenKey].length">
                    <svg width="4" height="8" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.666504 7.33463L3.99984 4.0013L0.666504 0.667969V7.33463Z" fill="black"/>
                    </svg>
                </span>
                <span class="name">{{ item.name }}</span>
            </div>
        </div>
        <transition name="component-height" mode="out-in">
            <div 
                v-if="expanded"
                class="children"  
                :style="{'padding-left': 10 + 'px'}"

            >
                <div class="item" v-for="(child, index) in item[childrenKey]" :key="index">
                    <!-- <span>{{ child.name }}</span> -->
                    <TrainingCopyTreeItem 
                    :ref="'child'+index" 
                    :item="child" 
                    :treeType="treeType" 
                    :childrenKey="childrenKey" 
                    :item_group_id="item_group_id"
                    :level="level+1" 
                    :checkedSingleValue="checkedSingleValue" 
                    :checkedList="checkedList" 
                    @checkSingleValue="$emit('checkSingleValue', $event)"
                    />
                    <div 
                        class="default-trail" 
                        v-if="expanded && (index != (item[childrenKey].length - 1))"
                    >
                        
                    </div>
                </div>
            </div>
        </transition>
       
    </div>
</template>

<script>
import CheckBox from '@/components/layout/inputs/CheckBox'
import RadioButton from '@/components/layout/inputs/RadioButton'

export default {
    name: 'TrainingCopyTreeItem',
    components:{
        CheckBox,
        RadioButton
    },
    props:{
        item: Object,
        childrenKey: String,
        checkedList: Array,
        checkedSingleValue: [String,Number],
        treeType: String,
        item_group_id: [String,Number],
        level: {
            type: Number,
            default: 0
        }
    },
    data(){
        return{
            expanded: false,
            selected: false,
        }
    },
    methods:{
        checkItem(item){
            if(this.checkedList.includes(item.id)){
                this.checkedList.splice(this.checkedList.indexOf(item.id), 1);
            }else{
                this.checkedList.push(item.id);
            }
        }
    }
    
}
</script>

<style lang="scss" scoped>
.tree-item{
    display: flex;
    flex-direction: column;
    position: relative;

}
.item{
    position: relative;
}
.parent-name{
    display: flex;
    position: relative;
    text-align: left;
    cursor: pointer;
    color: #000;
    .arrow{
        display: flex;
        align-items: center;
        position: absolute;
        height: 100%;
        left: -0.8rem;
        svg{
            width: 13px;
            height: 13px;
            margin-top: 4px;
            transition: transform 0.3s ease-in-out;
        }
    }
    &.expanded{
        .arrow{
            svg{
                transform: rotate(90deg);
            }
        }
    }
}
.children{
    text-align: left;
    max-height: 100vh;
}
.default-trail{
    position: absolute;
    height: 100%;
    width: 1px;
    left: -2px;
    top: 0;
    background-color: #E4E7EC;
}
.child-trail{
    position: absolute;
    left: -1.02rem;
    top: -0.31rem;
}
.trail{
    position: absolute;
    height: 100%;
    left: 0.9rem;
}
.name-row{
    display: flex;
    align-items: center;
    gap: 0.6rem;
}
.empty{
    width: 25px;
    .circle{
        position: relative;
        border-radius: 50%;
        height: 18px;
        width: 18px;
        border: 1px solid #4D4D4D;
        cursor: not-allowed;
        span{
            position: absolute;
            margin: auto;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            border-radius: 50%;
            height: 2px;
            width: 100%;
            transform: rotate(45deg);
            background-color: #4D4D4D;
            &:nth-child(2){
                transform: rotate(-45deg);
            }
        }
    }
}
.component-height-enter-active, .component-height-leave-active {
  transition: opacity 0.3s ease, max-height .3s ease;
}
.component-height-enter, .component-height-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  max-height: 0;
}
</style>